<template>
  <div class="buttons-section" :class="{ expanded: isExpanded }">
    <div
      class="secondary-buttons d-inline-block"
      v-if="secondaryActions !== false && hideActions"
    >
      <slot name="secondary-buttons"></slot>
      <button
        class="btn btn-expand"
        :class="actionClass"
        @click="toggleExpanded"
      >
        <span v-show="!isExpanded">
          {{ __('ACTIONS') }} <i class="fas fa-ellipsis-h"></i>
        </span>
        <span v-show="isExpanded">
          <i class="fa fa-times"></i>
        </span>
      </button>
    </div>
    <div class="primary-button d-inline-block">
      <slot name="primary-button"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "ItemButtons",
  props: {
    actionType: String,
    secondaryActions: {
      type: [Array, Boolean],
      default: () => [],
    },
  },
  data() {
    return {
      isExpanded: false,
    };
  },
  computed: {
    actionClass() {
      return this.actionType === "secondary"
        ? "btn-secondary"
        : "btn-primary";
    },
    hideActions() {
      return Spark.userPermissions && Spark.userPermissions.manage_surveys;
    },
  },
  methods: {
    toggleExpanded() {
      this.isExpanded = !this.isExpanded;
    },
  },
};
</script>